// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { Document } from './document';
import { EmployeeClaim } from './employee-claim';
import { Transfer } from './transfer';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Lodgement extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  lodgementId!: number;
  adminId!: number;
  adminTypeId?: number;
  amount?: number;
  createdBy!: string;
  createdDate!: Date;
  data?: string;
  dateFrom?: Date;
  dateTo?: Date;
  documentSequenceNo!: number;
  dueDate!: Date;
  formId!: number;
  isFinal!: boolean;
  lodgementDate!: Date;
  lodgementUserUserId?: number;
  memo?: string;
  paymentDate?: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  admin!: Admin;
  documents!: Document[];
  employeeClaims!: EmployeeClaim[];
  lodgementUserUser!: User;
  transfers!: Transfer[];
}

